import "../../App.css"
import { useNavigate } from "react-router-dom"
import React, { useState } from "react"

const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_ORIGIN;

const SignUp = () => {
  const navigate = useNavigate();
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [username, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
 
  const handleSubmit = async (event) => {
    event.preventDefault();
    const emailRegex = /^[\w\-\.]+@([\w-]+\.)+[\w-]{2,}$/;
    if (!emailRegex.test(email)) {
      alert("Please enter a valid email!");
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ firstname, lastname, username, email, password })
    };
    const response = await fetch(`${BACKEND_ORIGIN}/signup`, requestOptions);
    const data = await response.json();
    if (response.ok) {
      localStorage.setItem("user", JSON.stringify({
        firstName: firstname,
        lastName: lastname,
        userName: username,
        uuid: data.uuid
      }));
      navigate("/app");
    }
    else {
      alert("Error signing up!: " + data.message);
    }
  }

  return (
    <div className="app-shell">
      <div className="main">
        <div className="logo-text" style={{display: "flex", fontSize: "64px", justifyContent: "center", alignItems: "center"}}>POST<span>GAME</span></div>
        <div className="logo-text" style={{display: "flex", fontSize: "56px", justifyContent: "center", alignItems: "center", paddingTop: "100px"}}>
          SIGN<span>UP</span>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{paddingLeft: "35%", paddingRight: "35%"}}>
            <div style={{display: "flex", justifyContent:"space-between", alignItems: "center", paddingBottom: "10px"}}>
              <input className="chat-input" type="text" placeholder="First Name" value={firstname} onChange={(e) => setFirstName(e.target.value)}></input>
              <input className="chat-input" type="text" placeholder="Last Name" value={lastname} onChange={(e) => setLastName(e.target.value)}></input>
            </div>
            <div style={{display: "flex", justifyContent:"space-between", alignItems: "center", paddingBottom: "10px"}}>
              <input className="chat-input" type="text" placeholder="Username" value={username} onChange={(e) => setUserName(e.target.value)}></input>
            </div>
            <div style={{display: "flex", justifyContent:"space-between", alignItems: "center", paddingBottom: "10px"}}>
              <input className="chat-input" type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}></input>
              <input className="chat-input" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}></input>
            </div>
            <div>
              <button className="sign-button" type="submit">Sign Up</button>
              <div><a href="./Login">Already have an account?</a></div>
            </div>
          </div>
        </form>
     </div>
    </div>
  );
};

export default SignUp;
